import { useEffect, useState } from 'react'
import { Button, Image } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const isImageFile = (fileType = '', fileName = '') => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']
  const extensionMatch = fileName?.split('.').pop()?.toLowerCase()
  const typeMatch = fileType?.startsWith('image/')
  return imageExtensions.includes(extensionMatch) || typeMatch
}

const AttachmentPreview = ({ msg, getImagePreview }) => {
  const [previewUrl, setPreviewUrl] = useState(null)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [imageLoadFailed, setImageLoadFailed] = useState(false)

  useEffect(() => {
    const loadPreview = async () => {
      const url = await getImagePreview(msg.attachmentId)
      setPreviewUrl(url)
    }
    loadPreview()
  }, [msg.attachmentId, getImagePreview])

  if (!previewUrl) return null

  const fileName = msg.attachment?.fileName || 'attachment'
  const fileType = msg.attachment?.fileType || ''

  if (isImageFile(fileType, fileName)) {
    return (
      <>
        {!imageLoadFailed ? (
          <Image
            src={previewUrl}
            alt={fileName}
            style={{
              width: '150px',
              height: 'auto',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onClick={() => setPreviewVisible(true)}
            onError={() => setImageLoadFailed(true)}
          />
        ) : (
          <a href={previewUrl} download={fileName}>
            <Button icon={<DownloadOutlined />} size="small">
              Download
            </Button>
          </a>
        )}
      </>
    )
  }

  return (
    <a
      href={previewUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'rgb(94 88 88)' }}
    >
      {fileName}
    </a>
  )
}

export default AttachmentPreview
